import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { RootState } from 'store';

import useStoreTranslation from 'hooks/useStoreTranslation';
import MENU_ENTRIES, { MenuRoles, MenuDisplay, MenuKey } from 'utils/menuEntries';

import { Container, MenuItem, MenuIcon, MenuName, Icon } from './styles';
import { getSessionToken } from 'services/sessionTokenService';
/* import { accountSuccessful } from 'action-creators/user'; */
import { updateAccount } from 'actions/user';

const DesktopMenu = () => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const userData = useSelector((state: RootState) => state.user.accountResult);

  const isAdmin = userData?.type === 'admin';
  const isSuperAdmin = userData?.type === 'superAdmin' || userData?.type === 'supportImplementation';
  const isSupportImplementation = userData?.type === 'supportImplementation';
  const isApprover = !!userData?.isGroupApprover;
  const isTravelArranger = userData?.isTravelArranger ?? false;
  const location = useLocation();
  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const {
    location: { pathname },
  } = history;

  const showMenu = (menuKey: MenuKey) => {
    // Expenses = 3
    if (menuKey === MenuKey.Expenses && companyConfiguration?.menuView?.hideExpenses) {
      return false;
    }

    // CostCenter = 9
    if (menuKey === MenuKey.CostCenter && companyConfiguration?.menuView?.hideCostCenter) {
      return false;
    }

    // Report = 10
    if (menuKey === MenuKey.Report && companyConfiguration?.menuView?.hideReports) {
      return false;
    }
    //AllReservationsReport = 16
    if (menuKey === MenuKey.AllReservationsReport && companyConfiguration?.menuView?.hideReports) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    
    const fetchDataInit = async () => {
      try {
        const response = await getSessionToken(userData.sessionToken);
        
        /* if (response.status === 404) {
          updateAccount(dispatch, { ...userData, bIsSessionToken: true });
          setShowModal(true);
        } */
      } catch (error) {
        console.error('Error al hacer la petición:', error);
        updateAccount(dispatch, { ...userData, bIsSessionToken: true });
        setShowModal(true);
        
      }
    };
    if (location.pathname !== '/corporate/login') {
      fetchDataInit();
    }
  }, [location]);

  return (
    <Container className="LeftMenu">
      {MENU_ENTRIES.filter((entry) => {
        if (!showMenu(entry.key)) return false;
        if (!entry.display.includes(MenuDisplay.Desktop)) return false;
        if (entry.roles.includes(MenuRoles.Traveler)) return true;
        if (entry.roles.includes(MenuRoles.Approver) && isApprover) return true;
        if (entry.roles.includes(MenuRoles.TravelArranger) && isTravelArranger) return true;
        if (entry.roles.includes(MenuRoles.Admin) && isAdmin) return true;
        if (entry.roles.includes(MenuRoles.SuperAdmin) && isSuperAdmin) return true;
        if (entry.roles.includes(MenuRoles.SupportImplementation) && isSupportImplementation) return true;
        return false;
      }).map((entry) => {
        const isEntryAdmin = entry.roles.includes(MenuRoles.Admin);
        const isEntryActive =
          pathname !== '/corporate/' &&
          [...entry.nestedRoutes, entry.mainRoute].some((route) => pathname.startsWith(route));

        if (
          pathname?.toLowerCase() === '/corporate/travelswithexpenses' &&
          companyConfiguration?.menuView?.downloadExcelExpenses
        ) {
          window.open('/corporate/FORMATO_REINTEGRO_VIAJES_Y_GASTOS_AL_EXTERIOR.xlsx', '_blank');

          if (isEntryAdmin || isSuperAdmin) {
            history.push('/corporate/dashboard');
          } else {
            history.push('/corporate/booking');
          }
        }

        return (
          <MenuItem
            key={entry.mainRoute}
            admin={isEntryAdmin}
            active={isEntryActive}
            onClick={() => history.push(entry.mainRoute)}
          >
            <MenuIcon admin={isEntryAdmin} active={isEntryActive}>
              <Icon small={entry.iconSmall} src={entry.iconSrc} />
            </MenuIcon>
            <MenuName admin={isEntryAdmin} active={isEntryActive}>
              {t(entry.name)}
            </MenuName>
          </MenuItem>
        );
      })}
    </Container>
  );
};

export default DesktopMenu;
